<template >
    <div v-if="visible">
        <!-- 启用、停用二次弹窗 -->
        <el-dialog
            :visible.sync="visible"
            title="充值"
            :width="'400px'"
            :before-close="cancelHandle"
          >
            <div class="content">
                <div>请向如下账户进行网银转账完成充值:</div>
                <div>开户名:平台交易资金待清算专户(车为家)</div>
                <div>开户行:平安银行广州珠江新城支行</div>
                <div>开户账户:1500 0111 1899 12</div>

                <div class="info-danger">重要提醒:需要使用绑定的银行卡,
                    绑定银行卡卡号:{{ row.bankCardNo }},
                    开户银行{{ row.bankShortName }}
                    进行转账</div>
            </div>
            <template slot="footer">
                <el-button
                    size="small"
                    type="primary"
                    @click="visible = false"
                >关闭</el-button>
            </template>
        </el-dialog>
    </div>
</template>

<script>

export default {
  name: 'PayDialog',
  data() {
    return {
      visible: false,
      row: {},
    }
  },
  methods: {
    // eslint-disable-next-line vue/no-unused-properties
    open(row) {
      this.row = row
      this.visible = true
    },
    cancelHandle() {
      this.visible = false
    },
  },
}
</script>

<style lang="scss" scoped>
.content{
    &>div{
        font-size: 14px;
        font-weight: 500;
        line-height: 28px;
        margin-bottom: 5px;
        color: #333;
    }
    .info-danger{
        color: #f56c6c;
        margin-top: 10px;
    }
}
</style>
